import { useState } from 'react';

export const useSearch = (initialValue = '') => {
  const [searchTerm, setSearchTerm] = useState(initialValue);

  const clearSearch = () => {
    setSearchTerm('');
  };

  return {
    searchTerm,
    setSearchTerm,
    clearSearch
  };
};
